import React from "react";
import PropTypes from "prop-types";
import ProductTag from "components/ProductTag";
import "./productAwards.scss";

/**
 * ProductAwards Component
 *
 * A component that displays multiple awards for a product
 *
 * @param {Object} props - Component props
 * @param {Array} props.awards - Array of award objects
 * @param {string} [props.className] - Additional CSS class for the component
 * @returns {JSX.Element} ProductAwards component
 */
const ProductAwards = ({ awards, className }) => {
  if (!awards || awards.length === 0) {
    return null;
  }

  return (
    <div className={`productAwardsContainer ${className || ""}`}>
      <div className="awardsWrapper">
        {awards.map((award, index) => (
          <React.Fragment key={index}>
            {index > 0 && <div className="awardSeparator"></div>}
            <ProductTag
              title={award.title}
              description={award.description}
              imageSrc={award.imageSrc}
              imageName={award.imageName}
              className="productAwardTag"
            />
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

ProductAwards.propTypes = {
  awards: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      imageSrc: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
        PropTypes.array
      ]).isRequired,
      imageName: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
        .isRequired
    })
  ).isRequired,
  className: PropTypes.string
};

export default ProductAwards;
